import { Input } from 'antd';
import React from 'react';
import { CategorySelector } from '../../../../common/components/CategorySelector/CategorySelector';
import { ClassIconWrapper } from '../../../../common/components/CategorySelector/CategorySelector.styles';
import { AssetClassIcon } from '../../../assets/components/AssetClassIcon';
import { DeepAnalysisReviewResultsRowCategory, ResultRowCell, ReviewNameSkeleton, ReviewValueSkeleton } from './DeepAnalysisReviewResultModal.styles';
import { ReactComponent as EditPencilSvg } from './assets/edit-pencil-icon.svg';
import { ReactComponent as NewRowIcon } from './assets/new-row-icon.svg'
import { DeepAnalysisReviewValueCell } from './DeepAnalysisReviewValueCell';

export const NameField = ({ isEdited, isHoverOn, isNew, value, onChange, showSkeleton, placeholder, bgColor, icon, showMissingFieldsError, onFocus }) => {
    return (
        <ReviewNameSkeleton active paragraph={false} loading={showSkeleton} avatar={{ size: 26, shape: 'circle' }}>
            {
                !isNew ?
                    <ClassIconWrapper style={{ borderRadius: '38px', marginRight: '0px' }} bgColor={bgColor}>
                        <AssetClassIcon name={icon} />
                    </ClassIconWrapper>
                    : (isEdited && <NewRowIcon />)
            }
            <ResultRowCell isActive={isEdited || isHoverOn || isNew}>
                <Input
                    value={value}
                    placeholder={placeholder}
                    onChange={onChange}
                    style={{
                        ...((isEdited || isHoverOn || isNew) ? {} : { borderColor: 'transparent', backgroundColor: 'transparent' }),
                        height: '48px', borderRadius: '8px',
                        ...(showMissingFieldsError && { borderColor: 'red' })
                    }}
                    suffix={!isEdited && isHoverOn && !isNew && <EditPencilSvg />}
                    onFocus={onFocus}
                />

            </ResultRowCell>
        </ReviewNameSkeleton>
    )
};

export const InstitutionNameField = ({ isEdited, isHoverOn, isNew, value, onChange, showSkeleton }) => {
    return (
        <ReviewNameSkeleton active paragraph={false} loading={showSkeleton} style={{ width: '164px', paddingLeft: '12px' }}>
            <ResultRowCell isActive={isEdited || isHoverOn || isNew} style={{ width: '164px' }}>
                <Input
                    value={value}
                    onChange={onChange}
                    style={{
                        ...((isEdited || isHoverOn || isNew) ? {} : { borderColor: 'transparent', backgroundColor: 'transparent' }),
                        height: '48px', borderRadius: '8px'
                    }}
                    suffix={!isEdited && isHoverOn && !isNew && <EditPencilSvg />}
                />
            </ResultRowCell>
        </ReviewNameSkeleton>
    )
};

export const ValueField = ({ isEdited, isHoverOn, isNew, handleFieldChange, fieldName, showSkeleton, value, currency, width, showCurrencyDropdown, showMissingFieldsError }) => {
    return (
        <ResultRowCell isActive={isEdited || isHoverOn || isNew} style={{ width: (width || '184px') }}>
            <ReviewValueSkeleton active paragraph={false} loading={showSkeleton} title={{ active: true, width: 92 }} style={{ width: '184px' }}>
                <DeepAnalysisReviewValueCell {...{ handleFieldChange, fieldName, isEdited, isHoverOn, isNew, value, currency, showCurrencyDropdown, showError: showMissingFieldsError }} />
            </ReviewValueSkeleton>
        </ResultRowCell>
    )
};

export const CategoryField = ({ currentItem, isEdited, isNew, showSkeleton, showMissingFieldsError, onCategoryChange, relevantClasses }) => {
    return (
        <DeepAnalysisReviewResultsRowCategory>
            <div style={{ width: `${(isNew && isEdited) ? '181px' : '264px'}`, marginRight: 0 }}>
                <CategorySelector
                    value={currentItem?.categoryId ?? null}
                    options={relevantClasses}
                    onCategoryChange={onCategoryChange}
                    showSkeleton={showSkeleton}
                    disabled={false}
                    withError={showMissingFieldsError}
                    selectMinHeight='33px'
                />
            </div>
        </DeepAnalysisReviewResultsRowCategory>
    )
};